<template>
  <div>
    <RoomName/>
    <TimeOutWarning/>
    <NetworkError v-if="networkError"/>
    <Settings />
    <InviteToRoom v-if="isFirstGame && !gameStarted && playersCount < 5"/>
    <div class="gameBoardWrapper d-flex flex-column">
      <PlayersList />
      <div class="boardWrap h-100 d-flex flex-column align-items-center justify-content-center">      
        <span class="boardInnerWrap">
          <div v-if="!gameStarted && playersCount==1" class="waitingForPlayers">
            Waiting for players 
            <b-spinner variant="primary" type="grow"></b-spinner>
          </div>
          <div v-if="!gameStarted && !isIamAdmin" class="waitingForPlayers">
            Waiting for admin to start 
            <b-spinner variant="primary" type="grow"></b-spinner>
          </div>
          <div v-if="isMyturn" class="waitingForPlayers turn">
            <b-spinner variant="primary" type="grow"></b-spinner>
            Your Turn
            <b-spinner variant="primary" type="grow"></b-spinner>
          </div>
          <div :class="['mt-1','mb-3', 'gameBoard', isMyturn ? 'myTurn' : '']">
            <FinalGameStatus />
            <Cell
              v-for="(cell, index) in cellArray"
              v-bind:key="index"
              :cellData="cell"
            ></Cell>
            <template v-if="!isIamNewPlayer">
              <div v-if="Diagonal_1" class="diagonal_1"></div>
              <div v-if="Diagonal_2" class="diagonal_2"></div>
              <div v-if="VerticalStrikes.Vertical_1" class="vertical_1"></div>
              <div v-if="VerticalStrikes.Vertical_2" class="vertical_2"></div>
              <div v-if="VerticalStrikes.Vertical_3" class="vertical_3"></div>
              <div v-if="VerticalStrikes.Vertical_4" class="vertical_4"></div>
              <div v-if="VerticalStrikes.Vertical_5" class="vertical_5"></div>
              <div v-if="HorizontalStrikes.Horizontal_1" class="horizontal_1"></div>
              <div v-if="HorizontalStrikes.Horizontal_2" class="horizontal_2"></div>
              <div v-if="HorizontalStrikes.Horizontal_3" class="horizontal_3"></div>
              <div v-if="HorizontalStrikes.Horizontal_4" class="horizontal_4"></div>
              <div v-if="HorizontalStrikes.Horizontal_5" class="horizontal_5"></div>
            </template>
          </div>
        </span>
        <BINGO />
      </div>
    </div>
  </div>  
</template>

<script>
import store from "@/store";
import Settings from "./Settings";
import PlayersList from "./PlayersList";
import Cell from "./Cell.vue";
import BINGO from "@/components/BINGO.vue";
import RoomName from "@/components/RoomName.vue";
import TimeOutWarning from "@/components/TimeOutWarning.vue";
import NetworkError from "@/components/NetworkError.vue";
import FinalGameStatus from "@/components/FinalGameStatus.vue";
import InviteToRoom from "@/components/InviteToRoom.vue";
import Helpers from "@/helpers";
import Server from "@/server";

export default {
  computed: {
    cellArray: () => store.getters.myCellArray,
    boardWidth: () => store.state.boardWidth - 100,
    boardHeight: () => store.state.boardHeight - 100,
    boardOffset: () => store.state.boardOffset * 2,
    Diagonal_1: () => store.getters.Diagonal_1,
    Diagonal_2: () => store.getters.Diagonal_2,
    HorizontalStrikes: () => store.getters.HorizontalStrikes,
    VerticalStrikes: () => store.getters.VerticalStrikes,
    CurrentPlayerId: () => store.state.room.myRoomCurrentPlayer,
    networkError: () => store.state.room.networkError,
    myId: () => store.state.player.id,
    isMyturn: () => store.getters.isMyturn,
    isIamAdmin: () => store.getters.isIamAdmin,
    gameStarted: () => store.state.room.gameStarted,
    isIamNewPlayer: () => store.getters.isIamNewPlayer,
    playersCount: () => store.getters.playersCount,
    isFirstGame: () => store.getters.isFirstGame
  },
  components: {
    Cell,
    BINGO,
    PlayersList,
    Settings,
    FinalGameStatus,
    InviteToRoom,
    RoomName,
    TimeOutWarning,
    NetworkError
  },
  watch: {
    CurrentPlayerId(){
      store.state.room.elapsedTime = 0;
      clearInterval(store.state.timer);
      store.state.timer = setInterval(() => {
        store.state.room.elapsedTime++;
      }, 1000);
    },
    gameStarted(newValue, oldValue) {
      if(newValue){
        store.state.room.elapsedTime = 0;
        clearInterval(store.state.timer);
        store.state.timer = setInterval(() => {
          store.state.room.elapsedTime++;
        }, 1000);
      }
      if (newValue != oldValue && this.isIamAdmin) {
        Server.initiateRoomUpdate();
      }
    }
  },
  mounted: () => {
    Helpers.browser.calculateSize();
    store.state.room.elapsedTime = 0;
  }
};
</script>
